import { FlightCalculatorFormValuesProps } from "src/@types/flightCalculatorSettings";
import axiosInstance from "../utils/axios";

const BASE_URL = "/cms/v1/component-settings/flight-calculator";

async function getFlightCalculatorSettingsByMerchantCodeApi(merchantCode: string) {
  return axiosInstance.get(`${BASE_URL}/active`, {
    params: { merchantCode }
  })
}

async function saveFlightCalculatorSettingsApi(merchantCode: string, data: FlightCalculatorFormValuesProps) {
  const savedSettings = await axiosInstance.post(`${BASE_URL}`, JSON.stringify(data));

  const activityCalculatorId = savedSettings.data.id;
  await connectMerchantToFlightCalculatorApi(merchantCode, activityCalculatorId);
  return savedSettings;
}

async function connectMerchantToFlightCalculatorApi(merchantCode: string, activityCalculatorId: string) {
  return axiosInstance.post(`${BASE_URL}/${activityCalculatorId}/merchant/${merchantCode}`)
}

async function updateFlightCalculatorSettingsApi(id: string, data: FlightCalculatorFormValuesProps) {
  return axiosInstance.put(`${BASE_URL}/${id}`, data);
}

export {
  getFlightCalculatorSettingsByMerchantCodeApi,
  saveFlightCalculatorSettingsApi,
  updateFlightCalculatorSettingsApi,
};